if (!customElements.get('extras-subscription')) {
    customElements.define(
      'extras-subscription',
      class ExtrasSubscription extends HTMLElement {
        constructor() {
            super();

            this.productForm = null;
        }

        toggleAddButton(button, added) {
            button.querySelector('span').textContent = added ? 'Added' : 'Add';
            button.classList.toggle('added', added);
        }

        connectedCallback() {
            this.productForm = this.closest('product-form');
            if (!this.productForm || this.productForm.tagName.toLowerCase() !== 'product-form') {
                console.error('El elemento padre no es product-form');
                return;
            }
            this.querySelectorAll('.cta-item').forEach(button => {
                button.addEventListener('click', this.onAddButtonClick.bind(this));
            });
        }

        onAddButtonClick(event) {
            event.preventDefault();

            if (!this.productForm) {
                console.error('No se encontró el elemento product-form');
                return;
            }

            const productContainer = event.currentTarget.closest('.slider-item .product-item');
            const variantId = productContainer.dataset.variantId;
            const sellingPlans = JSON.parse(event.currentTarget.dataset.sellingPlans);

            if (!this.productForm.additionalProducts) {
                this.productForm.additionalProducts = [];
            }

            const existingProduct = this.productForm.additionalProducts.find(p => p.variantId === variantId);

            if (existingProduct) {
                this.productForm.additionalProducts = this.productForm.additionalProducts.filter(p => p.variantId !== variantId);
                this.toggleAddButton(event.currentTarget, false);
            } else {
                this.productForm.additionalProducts.push({
                    variantId: variantId,
                    quantity: 1,
                    sellingPlans: sellingPlans
                });
                this.toggleAddButton(event.currentTarget, true);
            }
        }

        clearAddedProducts() {
            this.querySelectorAll('.cta-item').forEach(button => {
                this.toggleAddButton(button, false);
            });
        }

        disconnectedCallback() {
            this.querySelectorAll('.cta-item').forEach(button => {
                button.removeEventListener('click', this.onAddButtonClick.bind(this));
            });
        }
    });
}